// Unggah bertahap: berkas dipecah menjadi potongan kecil (±2MB) dan dikirim
// berurutan. Jaringan lambat/proxy tidak lagi memutus unggahan besar, dan
// kegagalan hanya mengulang potongan yang gagal — bukan seluruh berkas.
import { API } from "./api";

const FALLBACK_CHUNK = 2 * 1024 * 1024;

async function parseRes(res) {
  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }
  if (!res.ok) {
    const err = new Error(
      data && data.detail ? String(data.detail) : "Gagal mengunggah. Coba lagi."
    );
    err.status = res.status;
    throw err;
  }
  return data;
}

export async function uploadFileChunked({ file, basePath, onProgress }) {
  // basePath dapat memuat query (mis. `?year=2026`); pisahkan agar /init,
  // /chunk, /finish tidak "tenggelam" ke dalam query string.
  const [bpPath, bpQuery] = basePath.split("?");
  const q = bpQuery ? `?${bpQuery}` : "";
  const init = await parseRes(
    await fetch(`${API}${bpPath}/init${q}`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name: file.name, size: file.size }),
    })
  );
  const csize = init.chunkSize || FALLBACK_CHUNK;
  const total = Math.max(1, Math.ceil(file.size / csize));

  let refreshed = false;
  let n = 0;
  let misses = 0;
  try {
    while (n < total) {
      try {
        const res = await fetch(
          `${API}/api/monev/upload/${init.id}/chunk?n=${n}`,
          {
            method: "PUT",
            credentials: "include",
            headers: { "Content-Type": "application/octet-stream" },
            body: file.slice(n * csize, Math.min(file.size, (n + 1) * csize)),
          }
        );
        if (res.status === 401 && !refreshed) {
          const r = await fetch(`${API}/api/auth/refresh`, {
            method: "POST",
            credentials: "include",
          });
          if (r.ok) {
            refreshed = true;
            continue;
          }
        }
        await parseRes(res);
        n++;
        misses = 0;
        if (onProgress) onProgress(Math.min(99, Math.round((n / total) * 100)));
      } catch (e) {
        misses++;
        if (e.status === 409 || misses > 5) {
          if (e.status === 409) {
            // server mungkin sudah menerima potongan ini (putus saat jawaban
            // dikirim) — sinkronkan posisi dari server, bukan menulis dobel
            try {
              const st = await parseRes(
                await fetch(`${API}/api/monev/upload/${init.id}`, {
                  credentials: "include",
                })
              );
              n = Math.floor(st.received / csize);
            } catch {
              /* biarkan hits bertambah */
            }
          }
        }
        if (misses > 5) throw e;
        await new Promise((r) => setTimeout(r, 600 * misses));
      }
    }
    const fin = await parseRes(
      await fetch(`${API}/api/monev/upload/${init.id}/finish`, {
        method: "POST",
        credentials: "include",
      })
    );
    if (onProgress) onProgress(100);
    return fin;
  } catch (e) {
    // batalkan sesi agar tidak menyisakan berkas setengah jadi
    fetch(`${API}/api/monev/upload/${init.id}`, {
      method: "DELETE",
      credentials: "include",
    }).catch(() => {});
    throw e;
  }
}
